"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1249],{

/***/ 74055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GearIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87169);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





function GearIcon(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        x: 0,
        y: 0,
        xmlSpace: "preserve",
        width: 512,
        height: 512,
        viewBox: "0 0 512 512"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            d: "M500.633 211.454l-58.729-14.443a193.856 193.856 0 0 0-13.55-32.256c8.818-14.678 27.349-45.571 27.349-45.571a15.001 15.001 0 0 0-2.256-18.325l-42.422-42.422a14.958 14.958 0 0 0-18.325-2.256L347.055 83.53a193.24 193.24 0 0 0-32.065-13.433l-14.443-58.729A14.996 14.996 0 0 0 286 0h-60c-6.885 0-12.891 4.688-14.546 11.367 0 0-10.005 40.99-14.429 58.715a192.571 192.571 0 0 0-34.043 14.502l-47.329-28.403c-5.918-3.516-13.447-2.607-18.325 2.256l-42.422 42.422a15.001 15.001 0 0 0-2.256 18.325l29.268 48.882a193.296 193.296 0 0 0-11.821 28.901l-58.729 14.487A14.994 14.994 0 0 0 0 226v60c0 6.885 4.688 12.891 11.367 14.546l58.744 14.443c3.56 11.294 8.188 22.266 13.799 32.798l-26.191 43.652a15.001 15.001 0 0 0 2.256 18.325l42.422 42.422c4.849 4.849 12.407 5.771 18.325 2.256 0 0 29.37-17.607 43.755-26.221a193.254 193.254 0 0 0 32.549 13.696l14.429 58.715C213.109 507.313 219.115 512 226 512h60a14.995 14.995 0 0 0 14.546-11.367l14.429-58.715a190.535 190.535 0 0 0 33.281-14.136c14.78 8.862 44.443 26.66 44.443 26.66 5.903 3.53 13.462 2.622 18.325-2.256l42.422-42.422a15.001 15.001 0 0 0 2.256-18.325l-26.968-44.927a192.1 192.1 0 0 0 13.169-31.523l58.729-14.443A14.993 14.993 0 0 0 512 286v-60a14.994 14.994 0 0 0-11.367-14.546zM256 361c-57.891 0-105-47.109-105-105s47.109-105 105-105 105 47.109 105 105-47.109 105-105 105z",
            "data-original": "#000000",
            className: "prefix__active-path",
            "data-old_color": "#818295",
            fill: "#828396"
        })
    }));
};


/***/ }),

/***/ 57473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95576);
/* harmony import */ var _components_text_Dotdotdot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3552);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98777);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_powerplug__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41491);
/* harmony import */ var _govlaunch_popover__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70271);
/* harmony import */ var _lib_hooks_useShowMoreCounter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87386);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67459);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19026);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90489);














var Resources = function(param) {
    var resources = param.resources, _titleColor = param.titleColor, titleColor = _titleColor === void 0 ? _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .sealBlue */ .N9 : _titleColor, dataIntercomTarget = param.dataIntercomTarget;
    var ref = (0,_lib_hooks_useShowMoreCounter__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(resources.length, 4), offset = ref.offset, hasMore = ref.hasMore, showMore = ref.showMore;
    var paginated = resources ? resources.slice(0, offset) : [];
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    if (!Array.isArray(resources) || resources.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
        css: {
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .white */ .ix,
            borderRadius: 5,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .lightestGray */ .v2)
        },
        "data-intercom-target": dataIntercomTarget,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
                css: {
                    padding: 15,
                    textTransform: "uppercase",
                    fontSize: 12,
                    color: titleColor,
                    letterSpacing: 0.5,
                    fontWeight: 500
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    defaultMessage: "Resources",
                    id: "c/KktL"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
                css: {
                    borderTop: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .lightestGray */ .v2),
                    "> div:not(:first-of-type)": {
                        borderTop: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .lightestGray */ .v2)
                    }
                },
                children: paginated.map(function(resource, index) {
                    var isRecentlyAdded = isFresh(resource, resources);
                    return(// eslint-disable-next-line
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            resource.__typename === "DownloadResource" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Resource, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
                                        css: {
                                            width: 24,
                                            height: 24,
                                            minWidth: 24,
                                            minHeight: 24
                                        },
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(DocumentIcon, {
                                            width: 24,
                                            height: 24,
                                            style: {
                                                minWidth: 24,
                                                minHeight: 24
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
                                        css: {
                                            marginLeft: 10,
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_6__/* .Anchor */ .ee, {
                                                css: {
                                                    fontSize: 14,
                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkGray */ .O5,
                                                    textDecoration: "none",
                                                    fontWeight: 500,
                                                    lineHeight: 1.2,
                                                    "&:hover": {
                                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkGray */ .O5
                                                    }
                                                },
                                                href: resource.url,
                                                download: resource.filename,
                                                external: "govlaunch",
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_text_Dotdotdot__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                    clamp: 2,
                                                    children: resource.title
                                                })
                                            }),
                                            isRecentlyAdded && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("span", {
                                                css: {
                                                    fontSize: 10,
                                                    marginTop: 2.5,
                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkSkyLightBlue */ .XV
                                                },
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    defaultMessage: "\uD83D\uDD25 Recently added",
                                                    id: "wPk7g2"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            resource.__typename === "LinkResource" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Resource, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(LinkIcon, {
                                        width: 24,
                                        height: 24,
                                        style: {
                                            minWidth: 24,
                                            minHeight: 24
                                        }
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
                                        css: {
                                            marginLeft: 10,
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_6__/* .Anchor */ .ee, {
                                                css: {
                                                    fontSize: 14,
                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkGray */ .O5,
                                                    fontWeight: 500,
                                                    textDecoration: "none",
                                                    lineHeight: 1.2,
                                                    "&:hover": {
                                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkGray */ .O5
                                                    }
                                                },
                                                href: resource.url,
                                                external: "outside-govlaunch",
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_text_Dotdotdot__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                    clamp: 2,
                                                    children: resource.title
                                                })
                                            }),
                                            isRecentlyAdded && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("span", {
                                                css: {
                                                    fontSize: 10,
                                                    marginTop: 2.5,
                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkSkyLightBlue */ .XV
                                                },
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    defaultMessage: "\uD83D\uDD25 Recently added",
                                                    id: "wPk7g2"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            resource.__typename === "TextResource" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_powerplug__WEBPACK_IMPORTED_MODULE_3__/* .Toggle */ .ZD, {
                                children: function(param) {
                                    var on = param.on, toggle = param.toggle;
                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_govlaunch_popover__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        placement: "right",
                                        isOpen: on && !isMobile,
                                        onClickOutside: toggle,
                                        boxStyle: {
                                            boxShadow: "0 5px 30px 0 rgba(34, 35, 40, 0.2)"
                                        },
                                        render: function() {
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
                                                css: {
                                                    padding: 15,
                                                    maxWidth: 320,
                                                    whiteSpace: "pre-wrap"
                                                },
                                                children: resource.body
                                            });
                                        },
                                        children: function(param) {
                                            var innerRef = param.innerRef;
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Resource, {
                                                onClick: toggle,
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(FontIcon, {
                                                        width: 24,
                                                        height: 24,
                                                        style: {
                                                            minWidth: 24,
                                                            minHeight: 24
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
                                                        css: {
                                                            marginLeft: 10,
                                                            display: "flex",
                                                            flexDirection: "column"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("span", {
                                                                ref: innerRef,
                                                                css: {
                                                                    fontSize: 14,
                                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkGray */ .O5,
                                                                    lineHeight: 1.2,
                                                                    fontWeight: 500
                                                                },
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_text_Dotdotdot__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                                    clamp: 2,
                                                                    children: resource.title
                                                                })
                                                            }),
                                                            isRecentlyAdded && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("span", {
                                                                css: {
                                                                    fontSize: 10,
                                                                    marginTop: 2.5,
                                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkSkyLightBlue */ .XV
                                                                },
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                    defaultMessage: "\uD83D\uDD25 Recently added",
                                                                    id: "wPk7g2"
                                                                })
                                                            }),
                                                            isMobile && on && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("span", {
                                                                css: {
                                                                    fontSize: 13,
                                                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .mediumGray */ .rF,
                                                                    marginTop: 5
                                                                },
                                                                children: resource.body
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        }
                                    });
                                }
                            })
                        ]
                    }, index));
                })
            }),
            hasMore && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(ShowMore, {
                onClick: showMore
            })
        ]
    });
};
function isFresh(resource, resources) {
    var weekStart = moment__WEBPACK_IMPORTED_MODULE_2___default()().startOf("week");
    var isWithinTheWeek = moment__WEBPACK_IMPORTED_MODULE_2___default()(resource.addedAt) >= weekStart;
    if (isWithinTheWeek) {
        var daysAgo = moment__WEBPACK_IMPORTED_MODULE_2___default()(resource.addedAt).subtract(4, "days");
        return resources.slice().some(function(maybe) {
            return moment__WEBPACK_IMPORTED_MODULE_2___default()(maybe.addedAt) <= daysAgo;
        });
    }
    return false;
}
var ShowMore = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        role: "button",
        "aria-label": "Show more",
        css: {
            padding: 15,
            textTransform: "uppercase",
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .sealBlue */ .N9,
            fontSize: 12,
            textAlign: "center",
            cursor: "pointer",
            borderTop: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .lightestGray */ .v2),
            "&:hover": {
                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_7__/* .darkGray */ .O5
            }
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            defaultMessage: "Show more",
            id: "aWpBzj"
        })
    }));
};
var DocumentIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        viewBox: "0 0 16 22",
        width: 16,
        height: 22
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("g", {
            fill: "#28D094",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("path", {
                    d: "M12.643 10H3.357C3.143 10 3 9.8 3 9.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5zM12.643 7H8.357C8.143 7 8 6.8 8 6.5s.143-.5.357-.5h4.286c.214 0 .357.2.357.5s-.143.5-.357.5z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("path", {
                    d: "M15.636 22H.364C.145 22 0 21.853 0 21.633v-15.4c0-.073.073-.22.073-.293L5.89.073c.073 0 .218-.073.29-.073h9.455c.219 0 .364.147.364.367v21.266c0 .22-.145.367-.364.367zM.727 21.267h14.546V.733H6.327L.727 6.38v14.887z"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("path", {
                    d: "M6.611 7H.39C.156 7 0 6.844 0 6.611s.156-.389.389-.389h5.833V.39c0-.233.156-.389.39-.389C6.843 0 7 .156 7 .389V6.61C7 6.844 6.844 7 6.611 7zM12.643 13H3.357C3.143 13 3 12.8 3 12.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5zM12.643 16H3.357C3.143 16 3 15.8 3 15.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5zM12.643 19H3.357C3.143 19 3 18.8 3 18.5s.143-.5.357-.5h9.286c.214 0 .357.2.357.5s-.143.5-.357.5z"
                })
            ]
        })
    }));
};
var FontIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        viewBox: "0 0 340.111 340.111",
        width: "1em",
        height: "1em"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("path", {
                fill: "#28D094",
                d: "M340.111 76.316V65.175h-47.905v11.141h18.382v187.478h-18.382v11.141h47.905v-11.141h-18.382V76.316z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("g", {
                fill: "#28D094",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("path", {
                    d: "M2.067 229.59l56.068-126.615c3.909-8.731 11.03-14.018 20.684-14.018h2.068c9.648 0 16.544 5.286 20.449 14.018l56.07 126.615c1.149 2.528 1.84 4.825 1.84 7.124 0 9.421-7.354 17.004-16.776 17.004-8.272 0-13.788-4.825-17.004-12.18l-10.799-25.275H43.891l-11.26 26.426c-2.988 6.893-8.961 11.029-16.315 11.029C7.121 253.718 0 246.365 0 237.173c0-2.528.918-5.055 2.067-7.583zm99.501-44.579l-22.291-53.082-22.289 53.082h44.58zM176.011 216.951v-.46c0-26.885 20.452-39.294 49.635-39.294 12.41 0 21.373 2.068 30.105 5.056v-2.068c0-14.478-8.963-22.519-26.427-22.519-9.651 0-17.464 1.378-24.128 3.447-2.067.689-3.447.918-5.058.918-8.04 0-14.474-6.204-14.474-14.246 0-6.205 3.905-11.49 9.419-13.559 11.03-4.136 22.981-6.434 39.296-6.434 19.071 0 32.86 5.055 41.593 13.787 9.191 9.191 13.327 22.75 13.327 39.295v56.068c0 9.423-7.583 16.775-17.005 16.775-10.111 0-16.774-7.123-16.774-14.477v-.23c-8.502 9.421-20.224 15.625-37.226 15.625-23.211.002-42.283-13.324-42.283-37.684zm80.197-8.043v-6.204c-5.974-2.757-13.787-4.596-22.289-4.596-14.938 0-24.128 5.975-24.128 17.004v.46c0 9.422 7.813 14.936 19.072 14.936 16.315.001 27.345-8.96 27.345-21.6z"
                })
            })
        ]
    }));
};
var LinkIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        viewBox: "0 0 482.8 482.8",
        width: "1em",
        height: "1em"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("path", {
                fill: "#28D094",
                d: "M255.2 209.3c-5.3 5.3-5.3 13.8 0 19.1 21.9 21.9 21.9 57.5 0 79.4l-115 115c-21.9 21.9-57.5 21.9-79.4 0l-17.3-17.3c-21.9-21.9-21.9-57.5 0-79.4l115-115c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-115 115C8.7 322.7 0 343.6 0 365.8c0 22.2 8.6 43.1 24.4 58.8l17.3 17.3c16.2 16.2 37.5 24.3 58.8 24.3s42.6-8.1 58.8-24.3l115-115c32.4-32.4 32.4-85.2 0-117.6-5.2-5.3-13.8-5.3-19.1 0z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("path", {
                fill: "#28D094",
                d: "M458.5 58.2l-17.3-17.3c-32.4-32.4-85.2-32.4-117.6 0l-115 115c-32.4 32.4-32.4 85.2 0 117.6 5.3 5.3 13.8 5.3 19.1 0s5.3-13.8 0-19.1c-21.9-21.9-21.9-57.5 0-79.4l115-115c21.9-21.9 57.5-21.9 79.4 0l17.3 17.3c21.9 21.9 21.9 57.5 0 79.4l-115 115c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4l115-115c15.7-15.7 24.4-36.6 24.4-58.8 0-22.2-8.6-43.1-24.3-58.8z"
            })
        ]
    }));
};
var Resource = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        css: {
            padding: 15,
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.01)"
            }
        }
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Resources);


/***/ }),

/***/ 92136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ story_StoryListItem; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var router = __webpack_require__(22051);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-progressive-image@0.6.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-progressive-image/dist.js
var dist = __webpack_require__(78135);
// EXTERNAL MODULE: ./lib/hooks/useMediaWithInitialState.ts
var useMediaWithInitialState = __webpack_require__(3335);
// EXTERNAL MODULE: ./components/MobileDetectContext.ts
var MobileDetectContext = __webpack_require__(48582);
;// CONCATENATED MODULE: ./lib/hooks/useIsDesktop.ts



function useIsDesktop() {
    var mobileDetectContext = (0,react.useContext)(MobileDetectContext/* default */.Z);
    var isDesktop =  true ? (0,useMediaWithInitialState/* default */.Z)("(min-width: 960px)") : 0;
    return isDesktop;
};

// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./src/components/translation/TranslationButton.tsx
var TranslationButton = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/components/IntlRelativeTime.tsx
var IntlRelativeTime = __webpack_require__(89989);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/buttons/BookmarkButtonIcon.tsx
var BookmarkButtonIcon = __webpack_require__(43723);
;// CONCATENATED MODULE: ./components/icons/LockIcon.tsx




function LockIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 18,
        height: 24
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#005AEE",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M7.818 16.608l-.315 2.837A.501.501 0 0 0 8 20h2a.5.5 0 0 0 .497-.555l-.315-2.837c.512-.372.818-.961.818-1.608 0-1.103-.897-2-2-2s-2 .897-2 2c0 .647.306 1.236.818 1.608zM9 14c.551 0 1 .449 1 1a.992.992 0 0 1-.568.896.5.5 0 0 0-.28.506L9.442 19h-.883l.289-2.598a.5.5 0 0 0-.28-.506A.992.992 0 0 1 8 15c0-.551.449-1 1-1z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M17.5 9H16V7c0-3.86-3.14-7-7-7S2 3.14 2 7v2H.5a.5.5 0 0 0-.5.5V22c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V9.5a.5.5 0 0 0-.5-.5zM3 7c0-3.309 2.691-6 6-6s6 2.691 6 6v2h-1V7c0-2.757-2.243-5-5-5S4 4.243 4 7v2H3V7zm10 0v2H5V7c0-2.206 1.794-4 4-4s4 1.794 4 4zm4 15c0 .551-.449 1-1 1H2c-.551 0-1-.449-1-1V10h16v12z"
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./components/tag/TagsPreview.tsx
var TagsPreview = __webpack_require__(3081);
// EXTERNAL MODULE: ./components/text/Dotdotdot.tsx
var Dotdotdot = __webpack_require__(3552);
;// CONCATENATED MODULE: ./components/story/StoryDefaultCover.tsx





function StoryDefaultCover(_param) {
    var _width = _param.width, width = _width === void 0 ? 110 : _width, _height = _param.height, height = _height === void 0 ? 150 : _height, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            borderRadius: 5,
            height: height,
            width: width,
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#f1f0fc"
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: width,
            height: height,
            viewBox: "0 0 862 703"
        }, props), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                            id: "a",
                            x1: 232.86,
                            y1: 449.06,
                            x2: 232.86,
                            y2: 19.38,
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                    offset: 0,
                                    stopColor: "gray",
                                    stopOpacity: 0.25
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                    offset: 0.54,
                                    stopColor: "gray",
                                    stopOpacity: 0.12
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                    offset: 1,
                                    stopColor: "gray",
                                    stopOpacity: 0.1
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
                            id: "b",
                            x1: 303.14,
                            y1: 548.35,
                            x2: 303.14,
                            y2: 118.67,
                            xlinkHref: "#a"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
                            id: "c",
                            x1: 730.3,
                            y1: 703.19,
                            x2: 730.3,
                            y2: 444.62,
                            xlinkHref: "#a"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
                            id: "d",
                            x1: 732.71,
                            y1: 258.57,
                            x2: 732.71,
                            y2: 0,
                            xlinkHref: "#a"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    y: 19.38,
                    width: 465.71,
                    height: 429.68,
                    rx: 4.5,
                    ry: 4.5,
                    fill: "url(#a)",
                    opacity: 0.5
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 5.68,
                    y: 22.71,
                    width: 454.97,
                    height: 419.26,
                    rx: 4.5,
                    ry: 4.5,
                    fill: "#f5f5f5"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 40.75,
                    y: 91.77,
                    width: 76.73,
                    height: 69.06,
                    rx: 4.5,
                    ry: 4.5,
                    fill: "#6c63ff"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 140.49,
                    y: 91.77,
                    width: 305.02,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 140.49,
                    y: 114.79,
                    width: 305.02,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 198.34,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 221.35,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 252.05,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 275.06,
                    width: 237.86,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 305.68,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 328.7,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 359.39,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 33.07,
                    y: 382.41,
                    width: 237.86,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 70.29,
                    y: 118.67,
                    width: 465.71,
                    height: 429.68,
                    rx: 4.5,
                    ry: 4.5,
                    fill: "url(#b)",
                    opacity: 0.5
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 75.97,
                    y: 122,
                    width: 454.97,
                    height: 419.26,
                    rx: 4.5,
                    ry: 4.5,
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 111.03,
                    y: 191.06,
                    width: 76.73,
                    height: 69.06,
                    rx: 4.5,
                    ry: 4.5,
                    fill: "#6c63ff"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 210.78,
                    y: 191.06,
                    width: 305.02,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 210.78,
                    y: 214.08,
                    width: 305.02,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 297.63,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 320.65,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 351.34,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 374.36,
                    width: 237.86,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 404.97,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 427.99,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 458.68,
                    width: 412.44,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: 103.36,
                    y: 481.7,
                    width: 237.86,
                    height: 7.67,
                    rx: 3.44,
                    ry: 3.44,
                    fill: "#e0e0e0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "none",
                    stroke: "#535461",
                    strokeMiterlimit: 10,
                    d: "M536 276.74l4.36-4.12"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "none",
                    stroke: "#535461",
                    strokeMiterlimit: 10,
                    strokeDasharray: "12.58 12.58",
                    d: "M549.5 263.97l159.95-151.36"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "none",
                    stroke: "#535461",
                    strokeMiterlimit: 10,
                    d: "M714.02 108.28l4.35-4.12M537.63 427.99l4.47 4.01"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "none",
                    stroke: "#535461",
                    strokeMiterlimit: 10,
                    strokeDasharray: "12.44 12.44",
                    d: "M551.36 440.31l162.03 145.46"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fill: "none",
                    stroke: "#535461",
                    strokeMiterlimit: 10,
                    d: "M718.02 589.93l4.46 4"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 730.3,
                    cy: 573.91,
                    r: 129.29,
                    fill: "url(#c)",
                    opacity: 0.5
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 730.3,
                    cy: 573.2,
                    r: 126.56,
                    fill: "#f5f5f5"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M800.3 584.6c0 46.61-30.42 98.5-67.93 98.5s-67.93-51.9-67.93-98.5 30.42-70.27 67.93-70.27 67.93 23.65 67.93 70.27z",
                    fill: "#fdd835"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M730.66 700.14a126 126 0 0 0 69.57-20.82c-4.66-25.49-22.41-26.94-22.41-26.94H680s-16.75 1.38-22 24.82a126 126 0 0 0 72.66 22.94z",
                    fill: "#6c63ff"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M709.61 621.29h39.14v33.34a17.54 17.54 0 0 1-17.54 17.54h-4.06a17.54 17.54 0 0 1-17.54-17.54v-33.34z",
                    opacity: 0.1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M713 619.84h32.45a3.35 3.35 0 0 1 3.35 3.35v30a17.54 17.54 0 0 1-17.54 17.54h-4.06a17.54 17.54 0 0 1-17.54-17.54v-30a3.35 3.35 0 0 1 3.34-3.35z",
                    fill: "#fdb797"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M709.68 636.08a56.33 56.33 0 0 0 39.14.11v-4.81h-39.14z",
                    opacity: 0.1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 729.33,
                    cy: 582.59,
                    r: 56.1,
                    fill: "#fdb797"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    cx: 674.38,
                    cy: 580.2,
                    rx: 5.22,
                    ry: 9.79,
                    fill: "#fdb797"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    cx: 783.98,
                    cy: 580.2,
                    rx: 5.22,
                    ry: 9.79,
                    fill: "#fdb797"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M679.61 552.16s31.76 43.44 104.46 28.59c0 0 8.12-9.88-11.65-40.23s-74.81-25.41-92.81 11.64z",
                    opacity: 0.1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M679.61 551.46s31.76 43.41 104.46 28.59c0 0 8.12-9.88-11.65-40.23s-74.81-25.42-92.81 11.64z",
                    fill: "#fdd835"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 732.71,
                    cy: 129.29,
                    r: 129.29,
                    fill: "url(#d)",
                    opacity: 0.5
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 732.97,
                    cy: 128.46,
                    r: 126.56,
                    fill: "#f5f5f5"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M733.07 255.52a126 126 0 0 0 69.57-20.82c-4.66-25.49-22.41-26.94-22.41-26.94h-97.86s-16.75 1.38-22 24.82a126 126 0 0 0 72.7 22.94z",
                    fill: "#6c63ff"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 731.74,
                    cy: 125.79,
                    r: 61.09,
                    fill: "#333"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M712 176.67h39.14V210a17.54 17.54 0 0 1-17.54 17.54h-4.06A17.54 17.54 0 0 1 712 210v-33.33z",
                    opacity: 0.1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M715.37 175.22h32.45a3.35 3.35 0 0 1 3.35 3.35v30a17.54 17.54 0 0 1-17.54 17.54h-4.06A17.54 17.54 0 0 1 712 208.57v-30a3.35 3.35 0 0 1 3.37-3.35z",
                    fill: "#fdb797"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M712.1 191.46a56.33 56.33 0 0 0 39.14.11v-4.81H712.1z",
                    opacity: 0.1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 731.74,
                    cy: 137.97,
                    r: 56.1,
                    fill: "#fdb797"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M691.78 86.94s23.64 48 90.34 20.12l-15.53-24.35-27.53-9.88z",
                    opacity: 0.1
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M691.78 86.24s23.64 48 90.34 20.12L766.59 82l-27.53-9.88z",
                    fill: "#333"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M691.57 82.99a32.41 32.41 0 0 1 8-13.07c11-10.91 29.13-13.21 38.41-25.65a7.26 7.26 0 0 1-3.33 10.24c8.88-.06 19.19-.84 24.22-8.16a16.63 16.63 0 0 1-2.8 17.56c7.88.36 16.29 5.71 16.8 13.58.34 5.24-2.95 10.21-7.26 13.22s-9.52 4.39-14.66 5.52c-14.95 3.31-69.16 17.16-59.38-13.24z",
                    fill: "#333"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    cx: 675.61,
                    cy: 137.92,
                    rx: 5.22,
                    ry: 9.79,
                    fill: "#fdb797"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    cx: 787.84,
                    cy: 137.92,
                    rx: 5.22,
                    ry: 9.79,
                    fill: "#fdb797"
                })
            ]
        }))
    }));
};

// EXTERNAL MODULE: ./components/story/ToggleBookmark.tsx
var ToggleBookmark = __webpack_require__(87636);
;// CONCATENATED MODULE: ./components/story/StoryListItem.tsx


























var StoryListItem = function(_param) {
    var story = _param.story, props = (0,_object_without_properties/* default */.Z)(_param, [
        "story"
    ]);
    var viewerCanRead = story.viewerCanRead;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isDesktop = useIsDesktop();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bind, props), {
                        css: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/stories/[storySlug]",
                                as: "/stories/".concat(story.slug),
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            display: "flex",
                                            alignItems: "center",
                                            opacity: viewerCanRead ? 1 : 0.5
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
                                            src: story.verticalCover || "",
                                            placeholder: "",
                                            children: function(src, loading) {
                                                if (loading) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryDefaultCover, {
                                                        height: 120,
                                                        width: 80
                                                    });
                                                }
                                                if (!src) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryDefaultCover, {
                                                        height: 120,
                                                        width: 80
                                                    });
                                                }
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                                    src: src,
                                                    height: 120,
                                                    width: 80,
                                                    css: {
                                                        pointerEvents: "none",
                                                        borderRadius: 5,
                                                        objectFit: "cover",
                                                        minWidth: 80,
                                                        minHeight: 120
                                                    }
                                                });
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    marginLeft: 15,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "space-between",
                                    justifyContent: "flex-start",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            opacity: viewerCanRead ? 1 : 0.5
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/stories/[storySlug]",
                                            as: "/stories/".concat(story.slug),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                children: [
                                                    !isMobile && story.status && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                        mb: 5,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                            css: {
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                justifyContent: "space-between"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                    children: [
                                                                        story.status === "PUBLISHED" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                                            css: {
                                                                                fontSize: 12,
                                                                                fontWeight: 600,
                                                                                color: palette/* greenSuccess */.CU
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                    defaultMessage: "Published",
                                                                                    id: "w7tf2z"
                                                                                }),
                                                                                " •",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        story.status === "UNPUBLISHED" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                                            css: {
                                                                                fontSize: 12,
                                                                                fontWeight: 600,
                                                                                color: palette/* red */.Q6
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                    defaultMessage: "Unpublished",
                                                                                    id: "wbU4tD"
                                                                                }),
                                                                                " •",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("time", {
                                                                            dateTime: story.modifiedAt || story.createdAt,
                                                                            css: {
                                                                                fontSize: 12,
                                                                                fontWeight: 500,
                                                                                color: palette/* sealBlue */.N9
                                                                            },
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                                                                value: story.modifiedAt || story.createdAt
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                locale !== "en-US" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslationButton/* default */.Z, {
                                                                    paddingY: "4px",
                                                                    onClick: function(event) {
                                                                        event.preventDefault();
                                                                        event.stopPropagation();
                                                                        router_default().push("/stories/".concat(story.slug, "?lang=").concat(locale));
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                                        css: {
                                                            fontSize: 18,
                                                            margin: 0,
                                                            color: palette/* text */.fL,
                                                            textDecoration: "none",
                                                            display: "inline-flex",
                                                            borderBottom: "solid 1px transparent",
                                                            "&:hover": {
                                                                textDecoration: "underline"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dotdotdot/* default */.Z, {
                                                            clamp: 2,
                                                            children: story.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                        mt: 5,
                                                        mb: 10,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: {
                                                                fontSize: 14,
                                                                lineHeight: 1.1,
                                                                color: palette/* darkGray */.O5,
                                                                wordBreak: "break-word"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dotdotdot/* default */.Z, {
                                                                clamp: 2,
                                                                children: story.introduction
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "flex",
                                            alignItems: "flex-end",
                                            justifyContent: "space-between",
                                            marginTop: "auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                css: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "flex-start"
                                                },
                                                children: [
                                                    story.tags && story.tags.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsPreview/* default */.Z, {
                                                        tags: story.tags
                                                    }),
                                                    story.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                        mt: 8,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: {
                                                                opacity: viewerCanRead ? 1 : 0.5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                href: "/governments/[governmentSlug]/[[...content]]",
                                                                as: "/governments/".concat(story.government.slug),
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                                    css: {
                                                                        color: palette/* text */.fL,
                                                                        textDecoration: "none",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        paddingRight: 24
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                                            size: 28,
                                                                            image: story.government.logo || "",
                                                                            name: story.government.name,
                                                                            innovator: story.government.isInnovator
                                                                        }),
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                                            css: {
                                                                                color: palette/* text */.fL,
                                                                                marginLeft: 5,
                                                                                fontSize: 14,
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dotdotdot/* default */.Z, {
                                                                                    clamp: 1,
                                                                                    children: story.government.name
                                                                                }),
                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                                                                    maxWidth: "220px",
                                                                                    textAlign: "center",
                                                                                    label: story.government.city.countryName,
                                                                                    bg: "blue.600",
                                                                                    py: 2,
                                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                                                        display: "inline-flex",
                                                                                        ml: 2,
                                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                                                            countryCode: story.government.city.country,
                                                                                            width: 25,
                                                                                            height: 14
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Auth/* default */.ZP, {
                                                children: function(param) {
                                                    var user = param.user;
                                                    return user && viewerCanRead && isDesktop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        css: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            position: "absolute",
                                                            bottom: 0,
                                                            right: 0
                                                        },
                                                        children: hovered && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleBookmark/* default */.Z, {
                                                            targetId: story._id,
                                                            targetType: "STORY",
                                                            viewerDidBookmark: story.viewerDidBookmark || false,
                                                            children: function(toggleBookmark) {
                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookmarkButtonIcon/* default */.Z, {
                                                                    onClick: toggleBookmark,
                                                                    bookmarked: story.viewerDidBookmark || false,
                                                                    bookmarkedColor: palette/* primary */.T$,
                                                                    bookmarkedStrokeColor: palette/* primary */.T$
                                                                });
                                                            }
                                                        })
                                                    }) : null;
                                                }
                                            }),
                                            !viewerCanRead && !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                css: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LockIcon, {}),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            fontSize: 14,
                                                            fontWeight: 600,
                                                            color: palette/* innovatorBlue */.LD,
                                                            marginLeft: 10
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "You must Sign In to read this Story",
                                                            id: "uVvAvk"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })),
                    !viewerCanRead && isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center",
                            marginTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LockIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    fontSize: 14,
                                    fontWeight: 600,
                                    color: palette/* innovatorBlue */.LD,
                                    marginLeft: 10
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "You must Sign In to read this Story",
                                    id: "uVvAvk"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var story_StoryListItem = (StoryListItem);


/***/ }),

/***/ 77966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StoryListItemDividers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





function StoryListItemDividers(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        css: {
            "& > :not(:first-of-type)": {
                borderTop: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .lightestGray */ .v2)
            }
        }
    }));
};


/***/ }),

/***/ 59933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StoryListItemHoverContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_powerplug__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41491);




function StoryListItemHoverContainer(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(react_powerplug__WEBPACK_IMPORTED_MODULE_1__/* .Hover */ .TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                css: {
                    backgroundColor: hovered ? "rgba(250, 250, 250, 0.5)" : "inherit"
                }
            }, bind, props));
        }
    });
};


/***/ }),

/***/ 87636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ToggleBookmark; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18125);
/* harmony import */ var _apollo_client_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82280);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        mutation ToggleBookmark($targetId: ObjectId!, $targetType: BookmarkType!) {\n          toggleBookmark(targetId: $targetId, targetType: $targetType) {\n            __typename\n            ... on Product {\n              _id\n              viewerDidBookmark\n            }\n            ... on Story {\n              _id\n              viewerDidBookmark\n            }\n            ... on Project {\n              _id\n              viewerDidBookmark\n            }\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function ToggleBookmark(param) {
    var targetId = param.targetId, targetType = param.targetType, viewerDidBookmark = param.viewerDidBookmark, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_apollo_client_react_components__WEBPACK_IMPORTED_MODULE_3__/* .Mutation */ .m, {
        mutation: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject()),
        variables: {
            targetId: targetId,
            targetType: targetType
        },
        children: function(toggleBookmark) {
            return children(function() {
                toggleBookmark({
                    optimisticResponse: {
                        __typename: "Mutation",
                        toggleBookmark: {
                            __typename: getTypenameByTargetType(targetType),
                            _id: targetId,
                            viewerDidBookmark: !viewerDidBookmark
                        }
                    }
                });
            });
        }
    });
};
function getTypenameByTargetType(targetType) {
    if (targetType === "STORY") {
        return "Story";
    } else if (targetType === "PRODUCT") {
        return "PRODUCT";
    } else {
        return "PROJECT";
    }
}


/***/ }),

/***/ 3081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95576);



var TagsPreview = function(param) {
    var tags = param.tags;
    if (tags.length === 0) {
        return null;
    }
    if (tags.length > 1) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
            css: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
                    css: {
                        padding: "5px 10px",
                        backgroundColor: "rgba(219, 236, 247, 0.5)",
                        borderTopLeftRadius: 12.5,
                        borderBottomLeftRadius: 12.5,
                        fontSize: 12,
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .text */ .fL,
                        display: "inline-flex"
                    },
                    children: tags[0].name
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("span", {
                    css: {
                        lineHeight: "12px",
                        padding: "5px 10px",
                        backgroundColor: "#48A0DA",
                        borderTopRightRadius: 12.5,
                        borderBottomRightRadius: 12.5,
                        fontSize: 10,
                        display: "inline-flex",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .white */ .ix,
                        fontWeight: "bold",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: [
                        "+",
                        tags.length - 1
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
        css: {
            padding: "5px 10px",
            backgroundColor: "rgba(219, 236, 247, 0.5)",
            borderRadius: 12.5,
            fontSize: 12,
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .text */ .fL,
            display: "inline-flex"
        },
        children: tags[0].name
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TagsPreview);


/***/ }),

/***/ 2518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsTablet; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _lib_hooks_useMediaWithInitialState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3335);
/* harmony import */ var _components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48582);



function useIsTablet() {
    var mobileDetectContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var isMobile =  true ? (0,_lib_hooks_useMediaWithInitialState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("(min-width: 720px; max-width: 960px)") : 0;
    return isMobile;
};


/***/ })

}]);